import React, { useMemo } from 'react';
import { HeaderLeft, HeaderRight, Header } from '@/components/atoms/Section/Section.style';
import { Title } from '@/components/atoms/Title';
import { Table } from '../../components/atoms/Table/Table';
import { Container, HeaderContainer } from './BrandRestaurantsList.style';
import useBrandRestaurantsListVM from './BrandRestaurantsList.viewmodel';
import { SvyButton } from '../../components/savory/SvyButton';
import { FormattedMessage } from 'react-intl';
import CreateRestaurantForm from './components/CreateRestaurantForm/CreateRestaurantForm';
import { routes } from '@/core/router/routes';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';

const BrandRestaurantsList = () => {
    const {
        rows,
        columns,
        fetchData,
        fetchDataTotalCount,
        isNewRestaurantModalOpen,
        openNewRestaurantModal,
        closeNewRestaurantModal,
        canCreateRestaurant,
        isLoading,
        handleRowClick,
        brandId,
    } = useBrandRestaurantsListVM();
    const tabRoutes = useMemo(() => routes.filter(({ tab }) => tab === 'brands'), []);

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <Container>
                <CreateRestaurantForm
                    isOpen={isNewRestaurantModalOpen}
                    onHide={closeNewRestaurantModal}
                    brandId={brandId}
                />
                <HeaderContainer>
                    <Header>
                        <HeaderLeft>
                            <Title text="route.brandRestaurants" />
                        </HeaderLeft>
                        <HeaderRight>
                            {canCreateRestaurant && (
                                <SvyButton size="s" onClick={openNewRestaurantModal}>
                                    <FormattedMessage id="brandRestaurants.newRestaurant" />
                                </SvyButton>
                            )}
                        </HeaderRight>
                    </Header>
                    <div>
                        <Table
                            rows={rows}
                            emptyMessageId="table.noRowsAfterFilter"
                            columns={columns}
                            isSearchable
                            fetchData={fetchData}
                            fetchDataTotalCount={fetchDataTotalCount}
                            isLoading={isLoading}
                            onRowClick={handleRowClick}
                        />
                    </div>
                </HeaderContainer>
            </Container>
        </RouterNavigationTabs>
    );
};
export default BrandRestaurantsList;
